import type { ActivityLogSummaryFilters } from './activityLogTypes';

export const normalizeActivityLogSummaryFilters = (
  filters: ActivityLogSummaryFilters = {}
) => ({
  positionName: filters.positionName ?? undefined,
  workGroup: filters.workGroup?.trim() || undefined,
  dateFrom: filters.dateFrom ?? undefined,
  dateTo: filters.dateTo ?? undefined,
  search: filters.search?.trim() || undefined,
});

export const activityLogKeys = {
  base: ['activityLogs'] as const,
  incident: (incidentId: string) =>
    [...activityLogKeys.base, incidentId] as const,
  list: (incidentId: string) =>
    [...activityLogKeys.incident(incidentId), 'list'] as const,
  detail: (incidentId: string, logDate: string) =>
    [...activityLogKeys.incident(incidentId), 'detail', logDate] as const,
  summaryBase: (incidentId: string) =>
    [...activityLogKeys.incident(incidentId), 'summary'] as const,
  summary: (incidentId: string, filters: ActivityLogSummaryFilters = {}) =>
    [
      ...activityLogKeys.summaryBase(incidentId),
      normalizeActivityLogSummaryFilters(filters),
    ] as const,
} as const;
